import { render } from "./MessageMenu.vue?vue&type=template&id=0f60ff23"
import script from "./MessageMenu.vue?vue&type=script&lang=js"
export * from "./MessageMenu.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__